import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import UserBadge from "../../assets/images/svg-icons-material-io/badge_FILL0_wght400_GRAD0_opsz48.svg";
import CallAPI from "../../services/apiCalls";
import useUserStore from "../../utils/storeApp";
import $ from "jquery";
import { stateCodeArray } from "../../services/fakeDB/ListUser";
import { Tag } from "primereact/tag";
import TwoFactorIcon from "../../assets/images/2fa.png";

const DetailsUser = ({
  userDetails,
  updateUser,
  customerOrgVal,
}) => {
  const navigate = useNavigate();
  const { sharedObject, userRole, userToken, SetSharedObject, setSearchObj } =
    useUserStore((state) => ({
      userRole: state.userRole,
      userToken: state.userToken,
      SetSharedObject: state.SetSharedObject,
      sharedObject: state.sharedObject,
      setSearchObj: state.setSearchObj,
    }));
  function formatPhoneNumber(value) {
    if (!value) return value;
    const phoneNumber = value.replace(/[^\d]/g, "");
    const phoneNumberLength = phoneNumber.length;
    if (phoneNumberLength < 4) return phoneNumber;
    if (phoneNumberLength < 7) {
      return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(3)}`;
    }
    return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(
      3,
      6
    )}-${phoneNumber.slice(6, 10)}`;
  }
  const [detailUser, setDetailUser] = useState({}); //
  const [detailUserAdmin, setDetailUserAdmin] = useState(false);
  const [usrContact, setUsrContact] = useState({});
  const [userOrg, setUeserOrg] = useState([]);
  const [orgDetail, setOrgDetial] = useState({});
  const [userStatus, setUserStatus] = useState({});
  const [userAssignsharedEmails, setAssignSharedEmails] = useState([]);
  const [userAssignUserEmails, setAssignUserEmails] = useState([]);
  const [processing, setProcessing] = useState(false);
  const [msg, SetMsg] = useState("");
  const [msgSuccess, SetMsgSuccess] = useState(false);
  const [usersCreate, SetUsersCreate] = useState(false);
  const [customerObj, setCustomerObj] = useState("");
  const [directTrust, setDirectTrust] = useState(false);
  const [IDProofing, SetIDProofing] = useState(false);
  const [orgTrustedAgent, SetOrgTrustedAgent] = useState(false);
  const [orgAdmin, SetOrgAdmin] = useState(false);
  const [flag, setFlag] = useState(false);
  const [userObj, setUserObj] = useState(false);
  const [CustomerTwoFactor, SetCustomerTwoFactor] = useState(false);
  const [notExists, SetNotExists] = useState(true);

  useEffect(() => {
    SetNotExists(true);
    SetCustomerTwoFactor(userDetails.orgTFA);
    console.log(userDetails);
    setUserObj(userDetails);
    let userDet = userDetails ? userDetails.userDet : "";
    let userDetOrg = userDetails ? userDetails.userOrg : "";
    let userDetAdmin = userDetOrg[0]?.isRoleEditable && userDetOrg[0]?.isAdmin;
    let userContact = userDetails ? userDetails.userContact : "";
    let userStatus = userDetails ? userDetails.userContact : "";

    setDetailUser(userDet);
    setDetailUserAdmin(userDetAdmin);
    setUsrContact(userContact);
    SetUsersCreate(userContact?.createUsers);
    setUeserOrg(userDetOrg);
    setUserStatus(userStatus);

    getCustomerDetails(userContact.vendorId);
    const usrTemp = [];
    const sharedTemp = [];
    if (userDetails && userDetails.userEmails.length > 0) {
      userDetails.userEmails.map((el) => {
        if (el.userEmailTypeString === "Shared") {
          sharedTemp.push(el);
        } else {
          usrTemp.push(el);
        }
      });
    }
    setAssignSharedEmails(sharedTemp);
    setAssignUserEmails(usrTemp);
    var customer = sharedObject.vendorsObj.find((element) => {
      return element.id === parseInt(userDetails?.userContact?.vendorId);
    });
    SetSharedObject("TwoFactorObject", {});
    setCustomerObj(customer);
  }, [userDetails]);
  useEffect(() => {
    if (flag) navigate(flag, { replace: true });
  }, [flag, navigate]);
  const AdminToggle = async (org) => {
    setDetailUserAdmin(org.isAdmin);
    SetMsg("");
    SetErrCreateMsg(false);
    SetMsgSuccess(false);
    SetIDProofing(org.vendorRequiresIDProofing);
    // SetOrgTrustedAgent(org.vendorAllowsTrustedAgent);
    // SetOrgAdmin(org.isAdmin);
    setOrgDetial(org);
    let m = `Please confirm you want to remove ${detailUser?.name} as an administrator from ${org.organizationName} organization.`;
    SetMsg(m);

    $("#AssignAdminModal").modal("show");
  };

  const AssignUnassign = async () => {
    SetErrCreateMsg(false);
    let call = "";

    if (detailUserAdmin) {
      call =
        "/users/RemoveAsAdmin?userId=" +
        usrContact.id +
        "&orgId=" +
        orgDetail.organizationId;
    } else {
      call =
        "/users/AssignAsAdmin?userId=" +
        usrContact.id +
        "&orgId=" +
        orgDetail.organizationId +
        "&allowCreateUsers=" +
        orgAdmin +
        "&makeTrustedAgent=" +
        orgTrustedAgent +
        "&issueInvites=" +
        IDProofing +
        "&requireIdVerification=" +
        orgDetail.vendorRequiresIDProofing;
    }

    setProcessing(true);
    SetMsgSuccess(false);
    const res = await CallAPI(call, false, "get", userToken);
    await SetSharedObject("ResponseCode", res.code);
    if (res.status === "SUCCESS") {
      SetMsgSuccess(true);
      updateUser({ ...usrContact, orgId: userDetails.orgId });
    } else if (res.status === "SERVERERROR") {
      let msg = res.data;
      let str = "<div>";
      for (let el of msg) {
        str += `${el}`;
      }
      str += "</div>";
      SetMsg(str);
      SetErrCreateMsg(true);
      setProcessing(false);
    }
    setProcessing(false);
  };
  const [collapse, SetCollapse] = useState(false);
  const [IDsValue, SetIDsValue] = useState("");
  const [secondValue, SetSecondValue] = useState("");
  const [thirdValue, SetThirdValue] = useState("");
  const [addIdFlag, SetIdFlag] = useState(false);
  const [errCreateMsg, SetErrCreateMsg] = useState(false);

  const DeleteId = async (el) => {
    setProcessing(true);
    let call =
      "/users/DeleteUserId?userId=" +
      usrContact.id +
      "&recordId=" +
      el.recordId;
    const res = await CallAPI(call, null, "get", userToken);
    await SetSharedObject("ResponseCode", res.code);
    if (res.status === "SUCCESS") {
      updateUser({ ...usrContact, orgId: userDetails.orgId });
      setProcessing(false);
    } else if (res.status === "SERVERERROR") {
      setProcessing(false);
    }
  };
  const RemoveSharedEmail = async (el) => {
    setProcessing(true);
    let call =
      "/emails/RemoveSharedEmail?directEmailId=" +
      el.id +
      "&userId=" +
      el.userId;
    const res = await CallAPI(call, null, "get", userToken);
    await SetSharedObject("ResponseCode", res.code);
    if (res.status === "SUCCESS") {
      updateUser({ ...usrContact, orgId: userDetails.orgId });
      setProcessing(false);
    } else if (res.status === "SERVERERROR") {
      setProcessing(false);
    }
  };
  function isNumeric(n) {
    return (!isNaN(parseFloat(n)) && isFinite(n)) || n === "" || n === ".";
  }
  const [errMsg, SetErrMsg] = useState(null);
  const ToggleCreateUser = (val) => {
    SetErrCreateMsg(false);
    SetMsgSuccess(false);
    SetMsg(null);
    SetErrMsg(null);
    $("#RemoveCreateUserModal").modal("show");
  };
  const ConfirmToggleCreateUser = async () => {
    SetErrCreateMsg(false);
    SetMsg(null);
    SetErrMsg(null);
    if (usersCreate === true) {
      let call =
        "/users/RemovePermission?userId=" +
        usrContact.id +
        "&permissionName=Create Users";
      setProcessing(true);
      const res = await CallAPI(call, false, "get", userToken);
      await SetSharedObject("ResponseCode", res.code);
      if (res.status === "SUCCESS") {
        CloseRemoveCreateUserModal();
        updateUser({ ...usrContact, orgId: userDetails.orgId });
      } else if (res.status === "SERVERERROR") {
        let msg = res.data;
        let str = "<div>";
        for (let el of msg) {
          str += `${el}`;
        }
        str += "</div>";
        SetErrMsg(str);
        SetErrCreateMsg(true);
        setProcessing(false);
        SetUsersCreate(true);
      }
    } else {
      var call =
        "/users/AssignAsAdmin?userId=" +
        usrContact.id +
        "&orgId=" +
        userDetails.orgId +
        "&allowCreateUsers=" +
        true +
        "&makeTrustedAgent=" +
        orgTrustedAgent +
        "&issueInvites=" +
        IDProofing +
        "&requireIdVerification=" +
        IDProofing;
      const res = await CallAPI(call, false, "get", userToken);
      await SetSharedObject("ResponseCode", res.code);
      if (res.status === "SUCCESS") {
        CloseRemoveCreateUserModal();
        SetMsgSuccess(true);
        updateUser({ ...usrContact, orgId: userDetails.orgId });
        SetUsersCreate(true);
      } else if (res.status === "SERVERERROR") {
        setProcessing(false);
      }
    }
    setProcessing(false);
  };
  const ConfirmToogleTwoFactor = async () => {
    SetErrCreateMsg(false);
    let displayMsg = "";
    if (detailUser.twoFactorEnabled) {
      displayMsg = `Two-Factor Authentication has been successfully turned off for ${detailUser.name}.`;
    } else {
      displayMsg = `Two-Factor Authentication has been successfully turned on for ${detailUser.name}.`;
    }
    let call =
      "/users/UpdateTFASettings?userId=" +
      usrContact.id +
      "&tfaPhone=" +
      usrContact.tfaPhone +
      "&tfaEmail=" +
      usrContact.tfaEmail +
      "&tfaOn=" +
      usrContact.tfaOn;
    setProcessing(true);
    const res = await CallAPI(call, false, "get", userToken);
    await SetSharedObject("ResponseCode", res.code);
    if (res.status === "SUCCESS") {
      SetMsg(displayMsg);
      updateUser({ ...usrContact, orgId: userDetails.orgId });
    } else if (res.status === "SERVERERROR") {
      let msg = res.data;
      let str = "<div>";
      for (let el of msg) {
        str += `${el}`;
      }
      str += "</div>";
      SetErrMsg(str);
      SetErrCreateMsg(true);
      setProcessing(false);
    }
    setProcessing(false);
  };
  const getSeverity = (product) => {
    switch (product) {
      case "Active":
        return "success";
      case "Pending":
        return "warning";
      case "IDP Failed and Locked":
        return "danger";
      case "Failed":
        return "danger";
      case "Locked":
        return "danger";
      default:
        return null;
    }
  };
  const TwoFactorSignUp = async () => {
    $("#TwoFactorSignupModal").modal("show");
  };

  const getCustomerDetails = async (vendorId) => {
    var obj = sharedObject.vendorsObj;
    for (var i = 0; i < obj.length; i++) {
      var c = obj[i];
      if (c.id === vendorId) {
        setDirectTrust(c.directTrust);
      }
    }
  };
  const SearchNpi = async (valId) => {
    setProcessing(true);
    SetNotExists(true);
    let flag = false;
    let call = "/organization/SearchNPI?searchNPI=" + valId + "&npiType=1";
    const res = await CallAPI(call, false, "get", userToken);
    await SetSharedObject("ResponseCode", res.code);
    if (res.status === "SUCCESS") {
      let dt = res.data.data;
      if (dt && Object.keys(dt).length > 0 && dt.constructor === Object) {
        SetNotExists(true);
        flag = true;
      } else {
        SetNotExists(false);
        flag = false;
      }
    } else if (res.status === "SERVERERROR") {
      SetNotExists(false);
      setProcessing(false);
      flag = false;
    }
    setProcessing(false);
    return await flag;
  };
  const AddId = async () => {
    SetIdFlag(true);
    SetErrCreateMsg(false);
    if (IDsValue === "NPI") {
      let npiFlag = await SearchNpi(secondValue);
      if (!npiFlag) return;
    }
    let IdType = IDsValue === "NPI" ? 0 : IDsValue === "State" ? 1 : 2;
    let obj = {
      RecordId: 0,
      IDType: IdType,
      Value: IDsValue === "State" ? thirdValue : secondValue,
      IssuingAuthority: IDsValue === "State" ? secondValue : thirdValue,
    };
    setProcessing(true);
    let call = "/users/addUserId?userId=" + usrContact.id;
    const res = await CallAPI(call, obj, "post", userToken);
    await SetSharedObject("ResponseCode", res.code);
    console.log(res);
    if (res.status === "SUCCESS") {
      SetIDsValue("");
      SetSecondValue("");
      SetThirdValue("");
      SetIdFlag(false);
      updateUser({ ...usrContact, orgId: userDetails.orgId });
      setProcessing(false);
    } else if (res.status === "SERVERERROR") {
      let msg = res.data;
      let str = "<div>";
      for (let el of msg) {
        str += `${el}`;
      }
      str += "</div>";
      SetErrMsg(str);
      SetErrCreateMsg(true);
      setProcessing(false);
    }
    };

    const [loadingText, setLoadingText] = useState("Loading...");
    useEffect(() => {
        let timer;
        if (processing) {
            timer = setTimeout(() => {
                setLoadingText("Working on it...");
            }, 10000);
        } else {
            setLoadingText("Loading...");
        }

        return () => clearTimeout(timer);
    }, [processing]);

  const closeModal = (modalId) => {
    if (document.activeElement instanceof HTMLElement) {
        document.activeElement.blur();
    }

    $(`#${modalId}`).modal('hide');
    //modalTriggerRef.current?.focus();
};
//const modalTriggerRef = useRef(null);
const CloseDetailUser = () => closeModal('detailsUserModal');
const CloseAssignModal = () => closeModal('AssignAdminModal');
const CloseRoleConfirmModal = () => closeModal('UserRoleConfirmModal');
const CloseRemoveCreateUserModal = () => closeModal('RemoveCreateUserModal');
const CloseTwoFactorModal = () => closeModal('TwoFactorModal');
const CloseTwoFactorSignupModal = () => closeModal('TwoFactorSignupModal');
  // Add Escape key handler for modals
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === "Escape") {
        // Close any open modal
        if ($("#detailsUserModal").hasClass("show")) CloseDetailUser();
        if ($("#AssignAdminModal").hasClass("show")) CloseAssignModal();
        if ($("#UserRoleConfirmModal").hasClass("show")) CloseRoleConfirmModal();
        if ($("#RemoveCreateUserModal").hasClass("show")) CloseRemoveCreateUserModal();
        if ($("#TwoFactorModal").hasClass("show")) CloseTwoFactorModal();
        if ($("#TwoFactorSignupModal").hasClass("show")) CloseTwoFactorSignupModal();
      }
    };
    document.addEventListener("keydown", handleKeyDown);
    return () => document.removeEventListener("keydown", handleKeyDown);
  }, []);
  return (
    <div className="DetailsUser">
      <div
        className="modal fade "
        id="detailsUserModal"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="detailsUserModalTitle"
        aria-describedby="detailsUserModalDesc"
        data-backdrop="static"
        aria-modal="true"
      >
        <div className="modal-dialog modal-dialog-slideout">
          <div className="modal-content">
            <div className="modal-header">
              <h2
                className="modal-title spacer-inline text-size3"
                id="detailsUserModalTitle"
              >
                User Details
              </h2>
              <button
                type="button"
                className="close"
                aria-label="Close user details"
                onClick={CloseDetailUser}
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
                
              <div className="modal-body">
                  <p id="detailsUserModalDesc" className="sr-only">
                    View and manage user details including contact information, organizations, permissions, and identity documents.
                  </p>
                <div className="modal-content-body container">
                  <div className="details-header blk-clr">
                    <img
                      className="spacer-margin7"
                      src={UserBadge}
                      alt=""
                      aria-hidden="true"
                    />
                    <div className="text-size6 ft-wt blk-clr">
                      {detailUser?.name}
                    </div>
                    <div className="blk-clr">
                      <span id="detailsUserStatusTitle">Status:</span>{" "}
                      <Tag
                        value={userStatus?.status}
                        className="text-size1-1 text-lt"
                        severity={getSeverity(userStatus?.status)}
                        aria-labelledby="detailsUserStatusTitle"
                      ></Tag>
                    </div>
                    <div className="sp-margin1">
                      <button
                        className="btn btn-link p-0"
                        onClick={(el) => {
                          $("#editUserModal").modal("show");
                          el.preventDefault();
                        }}
                        aria-label="Edit User Details"
                        aria-haspopup="dialog"
                      >
                        <i className="bi bi-pencil-square sp-margin5" aria-hidden="true"></i>EDIT
                      </button>
                    </div>
                  </div>

                  <section className="field-wrapper" aria-label="User Information">
                    <dl>
                      <dt>Username:</dt>
                      <dd id="userName"> {detailUser?.userNameDisplay} </dd><br />
                      <dt>Address:</dt>
                      <dd id="addressesFirstLine" className="sp-margin5">
                        {usrContact.addresses && usrContact.addresses.length > 0
                          ? usrContact.addresses[0].firstLine
                          : ""}
                      </dd>
                      <dd id="addressesSecondLine" className="sp-margin5">
                        {usrContact.addresses && usrContact.addresses.length > 0
                          ? usrContact.addresses[0].secondLine
                          : ""}
                        ,
                      </dd>
                      <dd id="addressesCity" className="sp-margin5">
                        {usrContact.addresses && usrContact.addresses.length > 0
                          ? usrContact.addresses[0].city
                          : ""}
                        ,
                      </dd>
                      <dd id="addressesState" className="sp-margin5">
                        {usrContact.addresses && usrContact.addresses.length > 0
                          ? usrContact.addresses[0].state
                          : ""}
                      </dd>
                      <dd id="addressesPostalCode" className="sp-margin5">
                        {usrContact.addresses && usrContact.addresses.length > 0
                          ? usrContact.addresses[0].postalCode
                          : ""}
                      </dd><br />

                      <dt>Phone:</dt>
                      <dd id="phone" className="sp-margin5">
                      {usrContact.addresses && usrContact.addresses.length > 0
                        ? formatPhoneNumber(
                            usrContact.addresses[0].phone.substring(0, 10)
                          )
                        : ""}
                        </dd>

                     <dt htmlFor="ext">Ext:</dt>
                     <dd id="ext">
                        {usrContact.addresses &&
                        usrContact.addresses.length > 0
                        ? usrContact.addresses[0]?.phone.substring(
                            10,
                            usrContact.addresses[0].phone.length
                            )
                        : ""}
                      </dd><br />

                      <dt htmlFor="fax">Fax:</dt>
                      <dd id="fax" className="sp-margin5">
                      {usrContact.addresses && usrContact.addresses.length > 0
                        ? usrContact.addresses[0].fax
                          ? formatPhoneNumber(
                              usrContact.addresses[0].fax.substring(0, 10)
                            )
                          : ""
                        : ""}
                      </dd>
                      <dt htmlFor="ext">Ext:</dt>
                      <dd id="ext">
                        {usrContact.addresses &&
                        usrContact.addresses.length > 0
                            ? usrContact.addresses[0].fax
                              ? usrContact.addresses[0]?.fax.substring(
                                  10,
                                  usrContact.addresses[0].fax.length
                                )
                              : ""
                            : ""}
                        </dd><br />

                      <dt>Email:</dt>
                      <dd id="Email" className="sp-margin5">
                        {usrContact?.contactEmail}
                      </dd><br />

                      <dt>Direct Emails:</dt>
                      <dd id="DirectEmails" className="sp-margin5">
                        {/*{!userAssignUserEmails.length > 0 ? 0 : null}*/}

                        {userAssignUserEmails.length >= 0 ? (
                          <button
                            type="button" 
                            className="font-weight-bold btn btn-link p-0"
                            aria-label={`View ${userAssignUserEmails.length} direct email${userAssignUserEmails.length !== 1 ? "s" : ""}`}
                            onClick={(el) => {
                              let obj = {
                                Domain: usrContact?.domainName,
                                UserName: detailUser?.userName,
                                Name: detailUser?.name,
                                Flag: "detailUser",
                                Navigate: "detailUser",
                                Id: usrContact.id,
                                LastName: detailUser.lastName,
                                FirstName: detailUser.firstName,
                              };
                              SetSharedObject("UserIdEmail", obj);
                              CloseDetailUser();
                              setFlag("/emails");
                              el.preventDefault();
                            }}
                          >
                            {userAssignUserEmails.length}
                          </button>
                        ) : null}
                      </dd>
                    </dl>
                  </section>
                  <hr />
                  {/*User Info*/}
                  <section className="field-wrapper">
                    <dl>
                        <dt>Organization:</dt>
                        <dd>
                          <button
                            type="button"
                            className="btn btn-link p-0 ltr"
                            aria-label={`View organization ${userObj?.oName} details`}
                            onClick={() => {
                              let ob = {
                                id: userObj?.orgId,
                                OrganizationName: userObj?.oName,
                                ShowParent: "ShowParent",
                              };
                              setSearchObj(ob);
                              CloseDetailUser();
                              setFlag("/organizations");
                            }}
                          >
                            {userObj?.oName}
                          </button>
                        </dd><br />
                      <dt>Domain:</dt>
                      <dd>{usrContact?.domainName}</dd><br />
                      <dt>Last Login:</dt>
                      <dd>
                          {usrContact?.lastLoginTime
                          ? new Date(usrContact?.lastLoginTime).toLocaleString(
                              "en-US",
                              { hour12: false }
                            )
                          : ""}
                      </dd><br />
                      <dt>Modified By:</dt>
                      <dd>{usrContact?.modifiedBy?.split("|")[0]}</dd><br />
                      <dt>Date Created:</dt>
                      <dd>
                        {new Date(usrContact?.dateCreated).toLocaleString(
                          "en-US",
                          { hour12: false }
                        )}
                      </dd><br />
                      <dt>Require ID Proofing:</dt>
                      <dd>
                        {usrContact?.requireIdVerification &&
                        customerObj?.idProofingRequired
                          ? "YES"
                          : "NO"}
                      </dd><br />
                      <dt>DirectTrust:</dt>
                      <dd>{directTrust ? "YES" : "NO"}</dd><br />
                      <dt>Trusted Agent:</dt>
                      <dd>
                        {usrContact?.trustedAgent &&
                        customerObj?.trustedAgentAgreement
                          ? "YES"
                          : "NO"}
                      </dd>
                    </dl>
                  </section>

                  <section className="field-wrapper" aria-labelledby="specialtyHeading">
                    <span className="custom-label" id="specialtyHeading" >Specialty</span>
                    <div className="sub-catg" >
                       <dl  className="sp-mx7">
                           <dt>Type:</dt>
                           <dd>
                            {usrContact.specialties &&
                            usrContact.specialties.length > 0
                              ? usrContact.specialties[0].type
                              : ""}
                           </dd><br />
                           <dt>Classification:</dt>
                           <dd>
                            {usrContact.specialties &&
                            usrContact.specialties.length > 0
                              ? usrContact.specialties[0].classification
                              : ""}
                           </dd><br />
                           <dt>Specialization:</dt>
                           <dd>
                            {usrContact.specialties &&
                            usrContact.specialties.length > 0
                              ? usrContact.specialties[0].specialization
                              : ""}
                           </dd>
                       </dl>
                    </div>
                  </section>

                  <section aria-labelledby="organizationTitle">
                      <div className="label-divider">
                        <h6 className="sp-pad9" id="organizationTitle">Organization</h6>
                      </div>
                      <div className="field-wrapper o-flow">
                        <table aria-label="Organizations">
                            <caption className="sr-only">
                                Organizations and roles associated with this user.
                            </caption>
                          <thead>
                            <tr>
                              <th scope="col">Name</th>
                              <th scope="col">Role</th>
                              <th scope="col">Admin</th>
                            </tr>
                          </thead>
                          <tbody>
                            {userOrg.length > 0
                              ? userOrg?.map((el, idx) => {
                                  return (
                                    <tr key={el.organizationId}>
                                      <td>{el.organizationName}</td>
                                      <td className="w-sm"> {el.roleName}</td>
                                      <td className="w-sm">
                                        <input
                                          type="checkbox"
                                          checked={el.isAdmin}
                                          aria-label={`Set ${el.organizationName} admin`}
                                          onClick={(e) => {
                                            AdminToggle(el);
                                          }}
                                        />
                                      </td>
                                    </tr>
                                  );
                                })
                              : null}
                          </tbody>
                        </table>
                      </div>
                  </section>

                  <section aria-labelledby="assignedOrgEmailsTitle">
                      <div className="label-divider">
                        <h6 className="sp-pad9" id="assignedOrgEmailsTitle">
                          Assigned Organization Emails
                        </h6>
                      </div>
                      <div className="field-wrapper o-flow">
                        <table aria-label="Assigned organization emails">
                            <thead>
                                  <tr>
                                    <th scope="col">Email</th>
                                    <th scope="col">Purpose</th>
                                    <th scope="col">Action</th>
                                  </tr>
                              </thead>
                          {userAssignsharedEmails.length > 0
                            ? userAssignsharedEmails?.map((el) => {
                                return (
                                <tbody>
                                  <tr key={el.id}>
                                    <td className="word-set">
                                      {el.directEmailAddress}
                                    </td>
                                    <td className="w-sm">
                                      {el.emailPurposeTypeString}
                                    </td>
                                    <td className="w-sm">
                                      <button
                                        type="button"
                                        className="font-weight-bold btn btn-link p-0"
                                        aria-label={`Unassign ${el.directEmailAddress || "this email"}`}
                                        onClick={(e) => {
                                          RemoveSharedEmail(el);
                                          e.preventDefault();
                                        }}
                                      >
                                        Unassign
                                      </button>
                                    </td>
                                  </tr>
                                </tbody>
                                );
                              })
                            : null}
                        </table>
                        {userAssignsharedEmails?.length === 0 ? (
                          <div className="sub-catg" aria-live="polite" aria-atomic="true" role="alert">
                            There are no organization emails assigned to this user.
                          </div>
                        ) : null}
                      </div>
                  </section>

                  {/*Permissions - For Admins Only*/}
                  <section aria-labelledby="permissionsTitle">
                      <div className="field-wrapper label-divider">
                        <h6 className="sp-pad9" id="permissionsTitle">Permission</h6>
                      </div>
                      <div className="field-wrapper">
                        <div>
                          <label htmlFor="TwoFactorAuthentication">Two-Factor Authentication:</label>
                          {CustomerTwoFactor === true ? (
                            <div className="spacer-inline">
                              {usrContact?.twoFactorEnabled ? (
                                <button
                                  className={
                                    'btn btn-link twofa-setting-gear' +
                                    (!usrContact.twoFactorEnabled ? "gray" : "")
                                  }
                                  type="button"
                                  onClick={(el) => {
                                    const tm = Date.now();
                                    var obj = { ...usrContact, TimeStamp: tm };
                                    SetSharedObject("TwoFactorObject", obj);
                                    $("#TwoFactorSettingModal").modal("show");
                                    el.preventDefault();
                                  }}
                                >
                                  <i className="bi bi-gear-fill" aria-hidden="true"></i>
                                </button>
                              ) : (
                                <button
                                  className={"gray btn btn-link p-0"}
                                  type="button"
                                  onClick={(el) => el.preventDefault()}
                                >
                                  <i className="bi bi-gear-fill" aria-hidden="true"></i>
                                </button>
                              )}
                            </div>
                          ) : (
                            <button
                              className="btn btn-outline-info"
                              onClick={(el) => {
                                TwoFactorSignUp();
                                el.preventDefault();
                              }}
                            >
                              Learn More
                            </button>
                          )}
                        </div>
                        <div>
                          <label htmlFor="Administrator" className="spacer-margin8">Administrator:</label>
                          <input
                            className="form-control spacer-margin5"
                            type="checkbox"
                            name="Administrator"
                            id="Administrator"
                            onChange={(el) => {
                              let o = {
                                vendorRequiresIDProofing:
                                  userOrg[0].vendorRequiresIDProofing,
                                vendorAllowsTrustedAgent:
                                  userOrg[0].vendorAllowsTrustedAgent,
                                isAdmin: userOrg[0].isAdmin,
                                organizationName: userOrg[0].organizationName,
                                isRoleEditable: userOrg[0].isRoleEditable,
                                organizationId: userOrg[0].organizationId,
                              };
                              AdminToggle(o);
                            }}
                            value={detailUserAdmin}
                            checked={detailUserAdmin}
                            disabled={
                              usrContact.status === "Pending" && !userOrg[0].isAdmin
                                ? true
                                : false
                            }
                          />
                        </div>
                        {detailUserAdmin ? (
                          <div>
                            <label htmlFor="CreateUsers" className="spacer-margin8">Create Users: </label>
                            <input
                              type="checkbox"
                              className="spacer-margin5"
                              checked={usersCreate}
                              value={usersCreate}
                              onChange={(el) => ToggleCreateUser(el.target.checked)}
                              disabled={!detailUserAdmin}
                            />
                          </div>
                        ) : (
                          <div>
                            <label htmlFor="CreateUsers" className="spacer-margin8">Create Users: </label>
                            <span>{usrContact?.usersCreate ? "YES" : "NO"}</span>
                          </div>
                        )}
                      </div>
                  </section>

                  {/*ID Info*/}
                  <section aria-labelledby="idTitle">
                      <div className="label-divider">
                        <h6 className="sp-pad9 spacer-inline" id="idTitle">ID</h6>
                        <div className="v-set2 spacer-inline float-r">
                          <button
                            className="btn btn-info min-wsm"
                            onClick={(el) => {
                              SetCollapse(!collapse);
                              el.preventDefault();
                            }}
                            type="button"
                            aria-controls="ID-form"
                            aria-expanded={collapse}
                            aria-label={collapse ? "Collapse ID form" : "Expand ID form"}
                          >
                            <i
                              className={`bi ${!collapse ? "bi-plus" : "bi-dash"}`}
                              aria-hidden="true"
                            ></i>
                          </button>
                        </div>
                     </div>
                      <div
                        id="ID-form"
                        className={`field-wrapper ${!collapse ? "collapse" : null}`}
                      >
                        <select
                          className="form-control w-md2 sp-margin13 spacer-inline sp-margin5"
                          aria-label="Select ID type"
                          onChange={(el) => {
                            SetIDsValue(el.target.value);
                            SetSecondValue("");
                            SetNotExists(true);
                            if (el.target.value === "NPI") {
                              SetThirdValue("CMS");
                            } else {
                              SetThirdValue("");
                            }
                          }}
                        >
                          <option value={""}>Select</option>
                          <option value={"NPI"}>NPI</option>
                          <option value={"State"}>State License</option>
                          <option value={"Other"}>Other</option>
                        </select>
                        {IDsValue === "State" ? (
                          <>
                            <select
                              className="form-control w-md2 sp-margin13 spacer-inline"
                              value={secondValue}
                              aria-label="Select issuing state"
                              onChange={(el) => SetSecondValue(el.target.value)}
                            >
                              <option value={""}>Issuing State</option>
                              {stateCodeArray.map((el) => (
                                <option key={el} value={el}>
                                  {el}
                                </option>
                              ))}
                            </select>
                            <input
                              className="form-control sp-margin13"
                              type="text"
                              placeholder="Enter Value"
                              aria-label="State license value"
                              autoComplete="off"
                              value={thirdValue}
                              onChange={(el) => SetThirdValue(el.target.value)}
                            />
                          </>
                        ) : IDsValue === "" ? null : (
                          <>
                            <input
                              className="form-control w-md2 sp-margin13 spacer-inline"
                              maxLength={IDsValue === "NPI" ? 10 : 16}
                              aria-label={IDsValue === "NPI" ? "NPI number (10 digits)" : "ID value"}
                              autoComplete="off"
                              value={secondValue}
                              onChange={(el) => {
                                let vl = el.target.value;
                                let chk = isNumeric(vl);
                                if (chk && IDsValue === "NPI") {
                                  SetSecondValue(el.target.value);
                                } else if (IDsValue === "Other") {
                                  SetSecondValue(el.target.value);
                                }
                              }}
                              type={IDsValue === "NPI" ? "tel" : "text"}
                              placeholder={
                                IDsValue === "NPI"
                                  ? "10 digit number"
                                  : "Enter Value"
                              }
                            />
                            <input
                              className="form-control sp-margin13"
                              type="text"
                              disabled={IDsValue === "NPI"}
                              aria-disabled={IDsValue === "NPI"}
                              aria-label="Issuing authority"
                              autoComplete="off"
                              value={thirdValue}
                              onChange={(el) => SetThirdValue(el.target.value)}
                              placeholder={
                                IDsValue === "NPI"
                                  ? "CMS"
                                  : " Enter Issuing Authority"
                              }
                            />
                          </>
                        )}

                        {addIdFlag &&
                        IDsValue === "NPI" &&
                        secondValue.length < 10 ? (
                          <div className="alert alert-danger" role="alert" aria-live="assertive" aria-atomic="true">
                            NPI must have 10 numbers.
                          </div>
                        ) : null}
                        {!notExists ? (
                          <div className="alert alert-danger" role="alert" aria-live="assertive" aria-atomic="true">
                            We could not connect or find NPI {secondValue} you
                            entered. Please double check your number and try again.
                          </div>
                        ) : null}
                        {addIdFlag &&
                        ((IDsValue === "State" && thirdValue === "") ||
                          (IDsValue === "Other" && secondValue === "")) ? (
                          <div className="alert alert-danger" role="alert" aria-live="assertive" aria-atomic="true">
                            ID value is required.
                          </div>
                        ) : null}
                        {errCreateMsg ? (
                          <div
                            className={`alert alert-danger`}
                            dangerouslySetInnerHTML={{ __html: errMsg }}
                            role="alert" aria-live="assertive" aria-atomic="true"
                          />
                        ) : null}
                        <button
                          className="btn btn-success sp-margin13"
                          type="button"
                          onClick={(e) => AddId()}
                          disabled={
                            IDsValue === ""
                              ? true
                              : IDsValue === "NPI" && secondValue.length < 10
                              ? true
                              : IDsValue === "State" &&
                                (secondValue === "" || thirdValue === "")
                              ? true
                              : IDsValue === "Other" && secondValue === ""
                              ? true
                              : false
                          }
                        >
                          Add
                        </button>
                      </div>

                  <table className="o-flow">
                    <caption className="sr-only">Identity documents associated with this user</caption>
                    <thead>
                        <tr>
                          <th scope="col" className="w-sm">Type</th>
                          <th scope="col">Value</th>
                          <th scope="col">Issuing Authority</th>
                          <th scope="col" className="ctr">Remove</th>
                        </tr>
                    </thead>
                    <tbody>
                        {usrContact?.iDs?.map((el) => (
                          <tr key={el.recordId}>
                            <td>{el.idTypeString}</td>
                            <td>{el.value}</td>
                            <td>{el.issuingAuthority}</td>
                            <td
                              className="ctr click-box"
                              onClick={(e) => DeleteId(el)}
                            >
                              <i className="bi bi-x-circle rd-clr"></i>
                            </td>
                          </tr>
                        ))}
                    </tbody>
                  </table>
                  {usrContact?.iDs?.length === 0 ? (
                    <div className="sub-catg" role="status">
                      There are no IDs created for this user.
                    </div>
                  ) : null}
                  </section>
                </div>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-outline-secondary"
                  onClick={CloseDetailUser}
                >
                  Close
                </button>
              </div>
          </div>
        </div>
      </div>

      <div
        className="modal fade"
        id="AssignAdminModal"
        data-backdrop="static"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="assignAdminModalTitle"
        aria-describedby="assignAdminModalDesc"
        aria-modal="true"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h3 className="modal-title" id="assignAdminModalTitle">
                {detailUserAdmin
                  ? "Unassign Administrator"
                  : "Assign Administrator"}
              </h3>
              <button
                type="button"
                className="close"
                aria-label={`Close ${detailUserAdmin ? "Unassign" : "Assign"} Administrator dialog`}
                onClick={CloseAssignModal}
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <p id="assignAdminModalDesc" className="sr-only">
                {detailUserAdmin ? "Confirm removal of administrator privileges." : "Select privileges to assign to the administrator."}
              </p>
              {msgSuccess ? (
                <p className="ctr sp-pad4" role="status" aria-live="polite" aria-atomic="true">
                  Member has been updated successfully.
                </p>
              ) : !detailUserAdmin ? (
                <>
                  <p className="descript-container">
                    Assign {detailUser?.name} as an administrator to
                    {orgDetail?.organizationName} with the following privileges:
                  </p>
                  <fieldset className="field-wrapper modal-content-form">
                      <legend className="sr-only">
                        Privileges for {detailUser?.name}
                     </legend>
                    {customerObj?.idProofingRequired ? (
                      <div>
                        <input
                          type="checkbox"
                          className="spacer-margin5"
                          id="priv-id-proofing"
                          checked={IDProofing}
                          value={IDProofing}
                          onClick={(e) => SetIDProofing(e.target.checked)}
                        />
                        <label htmlFor="priv-id-proofing" className="spacer-margin8">
                          Require ID Proofing
                        </label>
                      </div>
                    ) : null}
                    {(userRole === "SES ADMINISTRATOR" ||
                      userRole === "SYSTEMADMINISTRATOR") &&
                    customerObj?.trustedAgentAgreement ? (
                      <div>
                        <input
                          type="checkbox"
                           id="priv-trusted-agent"
                          className="spacer-margin5"
                          checked={orgTrustedAgent}
                          value={orgTrustedAgent}
                          onClick={(e) => SetOrgTrustedAgent(e.target.checked)}
                        />
                        <label htmlFor="priv-trusted-agent" className="spacer-margin8">Trusted Agent</label>
                      </div>
                    ) : null}
                    <div>
                      <input
                        type="checkbox"
                        id="priv-create-users"
                        className="spacer-margin5"
                        checked={orgAdmin}
                        value={orgAdmin}
                        onClick={(e) => SetOrgAdmin(e.target.checked)}
                      />
                      <label htmlFor="priv-create-users" className="spacer-margin8">Create Users</label>
                    </div>
                  </fieldset>
                </>
              ) : (
                <p className="ctr sp-pad4">
                  {`Please confirm you want to remove ${detailUser?.userNameDisplay} as an administrator from ${orgDetail.organizationName} organization.`}
                </p>
              )}
              {errCreateMsg ? (
                <div
                  className={`alert alert-danger`}
                  role="alert"
                  dangerouslySetInnerHTML={{ __html: msg }}
                  aria-live="assertive"
                  aria-atomic="true"
                />
              ) : null}
            </div>
            <div className="modal-footer">
              {msgSuccess ? null : (
                <button
                  type="button"
                  className="btn btn-success"
                  onClick={(e) => {
                    AssignUnassign();
                  }}
                  disabled={processing}
                  aria-busy={processing}
                >
                  {processing ? "Processing..." : "Confirm"}
                </button>
              )}
              <button
                type="button"
                className="btn btn-outline-secondary"
                onClick={CloseAssignModal}
              >
                {msgSuccess ? "Close" : "Cancel"}
              </button>
            </div>
          </div>
        {processing ? (
            <div 
                className="loader-container" 
                role="status" 
                aria-live="polite" 
                aria-atomic="true"
                aria-labelledby="details-user-loader"
            >
                <div className="spinner" aria-hidden="true"></div>
                <div className="loading-text" id="details-user-loader">{loadingText}</div>
            </div>
        ) : null}
         
        </div>
      </div>
      {/* Confirmation Modal for User Role Permissions*/}
      <div
        className="modal fade"
        id="UserRoleConfirmModal"
        data-backdrop="static"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="userRoleConfirmationTitle"
        aria-modal="true"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h3 className="modal-title" id="userRoleConfirmationTitle">
                Confirmation
              </h3>
              <button
                type="button"
                className="close"
                aria-label="Close role confirmation"
                onClick={CloseRoleConfirmModal}
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <p id="userRoleConfirmDesc" className="sr-only">Confirm changes to user administrator role.</p>
              {usersCreate ? (
                <div className={`ctr sp-pad4`}>
                  {`Please confirm you want to unassign ${detailUser?.userNameDisplay} as an administrator.`}
                </div>
              ) : (
                <div className={`ctr sp-pad4`}>
                  {`Please confirm you want to assign ${detailUser?.userNameDisplay} as an administrator.`}
                </div>
              )}
              {errCreateMsg ? (
                <div
                  className={`alert alert-danger`}
                  dangerouslySetInnerHTML={{ __html: errMsg }}
                  role="alert" aria-live="assertive" aria-atomic="true"
                />
              ) : null}
            </div>
            <div className="modal-footer">
              {msgSuccess ? null : (
                <button
                  type="button"
                  className="btn btn-success"
                  onClick={(e) => {
                    ConfirmToggleCreateUser();
                  }}
                  disabled={processing}
                  aria-busy={processing}
                >
                  {processing ? "Processing..." : "Confirm"}
                </button>
              )}
              <button
                type="button"
                className="btn btn-outline-secondary"
                onClick={CloseRoleConfirmModal}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Confirmation Modal for Create User Modal */}
      <div
        className="modal fade"
        id="RemoveCreateUserModal"
        data-backdrop="static"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="removeCreateUserConfirmationTitle"
        aria-describedby="removeCreateUserDesc"
        aria-modal="true"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h3 className="modal-title" id="removeCreateUserConfirmationTitle">
                Confirmation
              </h3>
              <button
                type="button"
                className="close"
                aria-label="Close create user permission confirmation"
                onClick={CloseRemoveCreateUserModal}
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <p id="removeCreateUserDesc" className="sr-only">Confirm changes to create users permission.</p>
              {usersCreate ? (
                <div className={`ctr sp-pad4`}>
                  {`Please confirm you want to remove permission to create new users for ${detailUser?.userNameDisplay}.`}
                </div>
              ) : (
                <div className={`ctr sp-pad4`}>
                  {`Please confirm you want ${detailUser?.userNameDisplay} to create new users.`}
                </div>
              )}
              {errCreateMsg ? (
                <div
                  className={`alert alert-danger`}
                  dangerouslySetInnerHTML={{ __html: errMsg }}
                  role="alert" aria-live="assertive" aria-atomic="true"
                />
              ) : null}
            </div>
            <div className="modal-footer">
              {msgSuccess ? null : (
                <button
                  type="button"
                  className="btn btn-success"
                  onClick={(e) => {
                    ConfirmToggleCreateUser();
                  }}
                  disabled={processing}
                  aria-busy={processing}
                >
                  {processing ? "Processing..." : "Confirm"}
                </button>
              )}
              <button
                type="button"
                className="btn btn-outline-secondary"
                onClick={CloseRemoveCreateUserModal}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Two Factor Settings Modal */}
      <div
        className="modal fade"
        id="TwoFactorModal"
        data-backdrop="static"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="twoFactorConfirmationTitle"
        aria-describedby="twoFactorConfirmDesc"
        aria-modal="true"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h3 className="modal-title" id="twoFactorConfirmationTitle">
                Confirmation
              </h3>
              <button
                type="button"
                className="close"
                aria-label="Close two-factor authentication confirmation"
                onClick={CloseTwoFactorModal}
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <p id="twoFactorConfirmDesc" className="sr-only">Confirm changes to two-factor authentication.</p>
              {usrContact.twoFactorEnabled ? (
                <p className={`ctr sp-pad4`}>
                  {`Do you want to turn off Two-Factor Authentication for ${detailUser?.userNameDisplay}?`}
                </p>
              ) : (
                <p className={`ctr sp-pad4`}>
                  {`Do you want to turn on Two-Factor Authentication for ${detailUser?.userNameDisplay}?`}
                </p>
              )}
              {errCreateMsg ? (
                <div
                  className={`alert alert-danger`}
                  dangerouslySetInnerHTML={{ __html: errMsg }}
                  role="alert" aria-live="assertive" aria-atomic="true"
                />
              ) : null}
            </div>
            <div className="modal-footer">
              {msgSuccess ? null : (
                <button
                  type="button"
                  className="btn btn-success"
                  onClick={(e) => {
                    ConfirmToogleTwoFactor();
                  }}
                  disabled={processing}
                  aria-busy={processing}
                >
                  {processing ? "Processing..." : "Confirm"}
                </button>
              )}
              <button
                type="button"
                className="btn btn-outline-secondary"
                onClick={CloseTwoFactorModal}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Two Factor Signup Modal */}
      <div
        className="modal fade"
        id="TwoFactorSignupModal"
        data-backdrop="static"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="twoFactorSignUpTitle"
        aria-describedby="twoFactorSignUpDesc"
        aria-modal="true"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h3 className="modal-title" id="twoFactorSignUpTitle">
                Two-Factor Authentication
              </h3>
              <button
                type="button"
                className="close"
                aria-label="Close two-factor authentication sign up"
                onClick={CloseTwoFactorSignupModal}
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <p id="twoFactorSignUpDesc" className="sr-only">Information about signing up for two-factor authentication.</p>
              <div className="ctr title-2">
                <img
                  src={TwoFactorIcon}
                  alt="Two Factor Authentication Badge"
                />
                <div className="sp-margin4">
                  Sign Up for Two-Factor Authentication
                </div>
              </div>
              <div className="modal-content-body descript-p">
                <div className="sp-margin3 text-reg">
                  <p>
                    Two-factor Authentication enhances the security of your
                    users by providing additional authentication code to protect
                    their account.
                  </p>
                  Setting up Two-Factor Authentication for your organization
                  will provide the capability to enable any users in your
                  organization with this added security. Contact your account
                  manager to find out how to sign up.
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-outline-secondary"
                onClick={CloseTwoFactorSignupModal}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DetailsUser;
